import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const sections = [
    {
      title: 'Solutions',
      links: [
        { label: 'Smart POS', href: '#services' },
        { label: 'Merchant Onboarding', href: '#services' },
        { label: 'Technical Support', href: '#services' }
      ]
    },
    {
      title: 'Company',
      links: [
        { label: 'About Us', href: '#about' },
        { label: 'Partnership', href: '#partnership' },
        { label: 'Clients', href: '#industries' },
        { label: 'Contact', href: '#contact' }
      ]
    },
    {
      title: 'Suggested Clients',
      links: [
        { label: 'Retail', href: '#industries' },
        { label: 'Restaurants', href: '#industries' },
        { label: 'Cafés', href: '#industries' },
        { label: 'Hospitality', href: '#industries' }
      ]
    }
  ];

  return (
    <footer className="bg-[#0A1128] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          <div className="lg:col-span-2">
            <div className="text-3xl font-bold mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              <span className="text-white">Syr</span>
              <span className="text-[#10B981]">veo</span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              A modern fintech startup building smart payment solutions for merchants across Europe and the Middle East.
            </p>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-gray-400">
                <Mail size={16} />
                <a href="mailto:info@syrveo.com" className="hover:text-[#10B981] transition-colors duration-300">
                  info@syrveo.com
                </a>
              </div>
              
              <div className="flex items-center space-x-3 text-gray-400">
                <MapPin size={16} />
                <span>Vienna, Austria </span>
              </div>
            </div>
          </div>

          {sections.map((section) => (
            <div key={section.title}>
              <h4 className="text-lg font-bold mb-4">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-gray-400 hover:text-[#10B981] transition-colors duration-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-400 text-sm">
            © {currentYear} Syrveo. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <a href="#" aria-label="LinkedIn" className="text-gray-400 hover:text-[#10B981] transition-colors duration-300" data-testid="footer-linkedin">
              <Linkedin size={20} />
            </a>
            <a href="#" aria-label="Twitter" className="text-gray-400 hover:text-[#10B981] transition-colors duration-300" data-testid="footer-twitter">
              <Twitter size={20} />
            </a>
            <a href="#" aria-label="Facebook" className="text-gray-400 hover:text-[#10B981] transition-colors duration-300" data-testid="footer-facebook">
              <Facebook size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
